import { AlignmentType, BorderStyle, HeadingLevel, ImageRun, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, TextWrappingSide, TextWrappingType, VerticalAlign, WidthType } from "docx";
import methodology from '../../../../../Assests/ReportImages/NetworkMethodology.png'

const setupMethodology = await fetch(methodology).then(response => response.blob())

const setUpMethodologyImage= new ImageRun({
    type: 'png',
    data: await setupMethodology.arrayBuffer(),
    transformation: {
        width: 575,
        height: 430
    },
});

export const setUpAndMethodologyNetwork = new Paragraph({
    spacing: { before: 150 },
    alignment: AlignmentType.CENTER,
    children: [setUpMethodologyImage]
})

export const NetworkNote = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "** For this VA engagement, Phase-4 (Admittance phase) not considered/executed as per sow.",
            size: 22,
            font: "Tahoma",
            color: '000000',
            italics:true
        }),
    ],
})

export const accrualPhasebullet1Network = new Paragraph({
    indent: { left:600 },
    spacing: { before: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Ping – sends an ICMP ECHO Request to a specific network host",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics:false
        })
    ]
})

export const accrualPhasebullet2Network = new Paragraph({
    indent: { left:600 },
    spacing: { before: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Telnet – attempts to establish an interactive telnet connection to a specific host system",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics:false
        })
    ]
})

export const accrualPhasebullet3Network = new Paragraph({
    indent: { left:600 },
    spacing: { before: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "NMAP– Scanning for the port which is opened at the firewall/Server",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics:false
        })
    ]
})

export const accrualPhasebullet4Network = new Paragraph({
    indent: { left:600 },
    spacing: { before: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Using port scanning utilities to identify any open ports or services (i.e., TCP 65,535 and UDP 65,535) on devices or servers reachable via internal corporate network",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics:false
        })
    ]
})

export const accrualPhasebullet5Network = new Paragraph({
    indent: { left:600 },
    spacing: { before: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Connecting to open ports using TCP or UDP network utilities to determine the type(s) of operating system(s), firewall application(s) and network service versions being used.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics:false
        })
    ]
})

export const acclimatizePhaseText1 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "As information is gathered about the targets, cross-referencing with databases of known vulnerabilities and current and past attack methods are performed.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics:false
        }),
    ],
})

export const acclimatizePhaseText2 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "After all open points have been assessed for external connectivity and open services, an attempt will be made to determine if any weak configuration settings or parameters are in use/set for any external system.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics:false
        }),
    ],
})

export const acclimatizePhaseText3 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Some of the specific steps we may execute include:",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics:false
        }),
    ],
})

export const acclimatizePhasebullet1 = new Paragraph({
    indent: { left: 600},
    alignment:AlignmentType.JUSTIFIED,
    spacing: { line: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Using open source, commercial and proprietary vulnerability testing tools and techniques to identify specific vulnerabilities or exposure points (e.g., Remote management related vulnerabilities, SNMP/HTTP management vulnerabilities, etc.)",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics:false
        })
    ]
})

export const acclimatizePhasebullet2 = new Paragraph({
    indent: { left: 600},
    alignment:AlignmentType.JUSTIFIED,
    spacing: { line: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Using comprehensive vulnerability scanning software to identify known problem areas Manual review conducted which included checking certain configuration files, checking auditing features that had been enabled or disabled, user and account policies etc.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics:false
        })
    ]
})


export const admittancePhaseTextNetwork = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "This phase was not performed as per the scope of the work.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics:false
        }),
    ],
})

export const affirmationPhaseTextNetwork = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "A detailed Assessment report is prepared and submitted to the client.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics:false
        }),
    ],
})
